const serverUrl = "https://us-central1-typexcad-cc750.cloudfunctions.net";
// const serverUrl = "http://127.0.0.1:5001/typexcad-cc750/us-central1";


export default serverUrl;